// extracted by mini-css-extract-plugin
module.exports = {"branding":"Branding_branding__6zLCX","logo":"Branding_logo__1uIqP","subtext":"Branding_subtext__3AgCQ"};